import { render, staticRenderFns } from "./VatRates.vue?vue&type=template&id=26bbd9ac&"
import script from "./VatRates.vue?vue&type=script&lang=ts&"
export * from "./VatRates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports